import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from './components/HeroCarousel';
import FeaturesRow from './components/FeaturesRow';
import EcosystemSection from './components/EcosystemSection';
import SolutionCards from './components/SolutionCards';
import IndustriesSection from './components/IndustriesSection';
import ProcessSection from './components/ProcessSection';
import WhyChooseSection from './components/WhyChooseSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel />
        <FeaturesRow />
        <EcosystemSection />
        <SolutionCards />
        <IndustriesSection />
        <ProcessSection />
        <WhyChooseSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}